import {TCrudMode} from "../synccycle";
import checkboxHtml from './checkbox.html?raw';

export const template = checkboxHtml;

interface IParams {
    crudMode: KnockoutObservable<TCrudMode>,
    toggle: KnockoutObservable<boolean>,
    prefix: string,
}

export class viewModel {
    constructor(private params: IParams) {
    }
}
